import * as l from "react";
import { i as o, b as r, E as a, x as i, r as s, c } from "../createReactComponent-58f9bea8.mjs";
import { n as y } from "../property-9daa16cd.mjs";
import { e as T } from "../class-map-2994e95e.mjs";
var k = Object.defineProperty, w = Object.getOwnPropertyDescriptor, b = (t, d, v, x) => {
  for (var g, e = x > 1 ? void 0 : x ? w(d, v) : d, m = t.length - 1; m >= 0; m--)
    (g = t[m]) && (e = (x ? g(d, v, e) : g(e)) || e);
  return x && e && k(d, v, e), e;
}, E = ((t) => (t.TEXT = "text", t.ICON_TEXT = "icon-text", t.ICON_TEXT_ALT = "icon-text-alt", t.DATE_TIME = "date-time", t.TEXT_STACKED = "text-stacked", t.AVATAR = "avatar", t))(E || {});
class f extends a {
  render() {
    return i`
      <div class="list">
        <slot></slot>
      </div>
    `;
  }
}
f.styles = o`
    ${r(`:host{min-width:var(--exo-size-8);display:block;font-size:var(--exo-font-size-small)}
`)}
  `;
class u extends a {
  constructor() {
    super(...arguments), this.height = "";
  }
  render() {
    return i`
      <style>
        :host .list-body {
          height: ${this.height ? this.height : "auto"};
          overflow: ${this.height ? "scroll" : "auto"};
        }
      </style>
      <div class="list-body">
        <slot></slot>
      </div>
    `;
  }
}
u.styles = o`
    ${r(`:host .list-body{padding:0 var(--exo-spacing-2x-small) var(--exo-spacing-2x-small)}
`)}
  `, b([y()], u.prototype, "height", 2);
class p extends a {
  render() {
    return i`
      <style>
        :host {
          cursor: ${this.clickable ? "pointer" : "default"};
        }
      </style>
      <div class="list-row" tabindex="0">
        <slot></slot>
      </div>
    `;
  }
}
p.styles = o`
    ${r(`:host .list-row{border-radius:calc(2 * var(--exo-radius-small));background:var(--exo-color-background);overflow:hidden;border:var(--exo-spacing-3x-small) solid transparent}:host .list-row:hover{background:var(--exo-color-background-action-hover-weak)}:host .list-row:active{background:var(--exo-color-background)}:host .list-row:focus-visible{outline:var(--exo-spacing-3x-small) solid var(--exo-color-background-action-hover);background:var(--exo-color-background-action-hover-weak)}:host slot{display:flex}
`)}
  `, b([y({ type: Boolean })], p.prototype, "clickable", 2);
class h extends a {
  constructor() {
    super(...arguments), this.cellType = "text";
  }
  render() {
    return i`
      <div
        class=${T({ "list-cell": !0, "list--cell-type-text": this.cellType === "text", "list--cell-type-icon-text": this.cellType === "icon-text", "list--cell-type-icon-text-alt": this.cellType === "icon-text-alt", "list--cell-type-date-time": this.cellType === "date-time", "list--cell-type-text-stacked": this.cellType === "text-stacked", "list--cell-type-avatar": this.cellType === "avatar" })}
      >
        <slot></slot>
      </div>
    `;
  }
}
h.styles = o`
    ${r(`:host{overflow:hidden;align-items:center;display:inline-flex}:host .list-cell{display:flex;height:var(--exo-spacing-2x-large);min-width:var(--exo-size-1);padding:var(--exo-spacing-2x-small) var(--exo-spacing-small);align-items:center;gap:var(--exo-spacing-2x-small)}:host .list-cell.list--cell-type-text{color:var(--exo-color-font);font:var(--exo-text-label-standard)}:host .list-cell.list--cell-type-icon-text{color:var(--exo-color-font);font:var(--exo-text-label-standard-semi-bold)}:host .list-cell.list--cell-type-icon-text-alt{color:var(--exo-color-font);font:var(--exo-text-label-standard)}:host .list-cell.list--cell-type-date-time{color:var(--exo-color-font-secondary);font:var(--exo-text-label-standard)}:host .list-cell.list--cell-type-text-stacked{font:var(--exo-text-label-standard-semi-bold);color:var(--exo-color-font);display:flex;flex-direction:column;justify-content:center;align-items:flex-start;gap:var(--exo-spacing-none);flex:1 0 0}:host .list-cell.list--cell-type-avatar{color:var(--exo-color-font-secondary);font:var(--exo-text-label-standard);display:flex;flex-shrink:0}
`)}
  `, b([y()], h.prototype, "cellType", 2);
class C extends a {
  render() {
    return i`
      <div class="list-cell-group">
        <slot></slot>
      </div>
    `;
  }
}
C.styles = o`
    ${r(`:host{background:none}:host slot{display:flex;height:100%}:host .list-cell-group{width:100%;height:100%}:host ::slotted(ex-list-col){text-align:center;text-align:-webkit-center}
`)}
  `;
class S extends a {
  render() {
    return i`
      <div class="list-sub-header">
        <slot></slot>
      </div>
    `;
  }
}
S.styles = o`
    ${r(`:host .list-sub-header{display:flex;min-height:var(--exo-spacing-large);padding:var(--exo-spacing-2x-small) var(--exo-spacing-x-small) var(--exo-spacing-2x-small) var(--exo-spacing-small);align-items:center;gap:var(--exo-spacing-x-small);color:var(--exo-color-font-secondary);font:var(--exo-text-label-micro)}
`)}
  `;
const n = (t = "") => {
  s("ex-structured-list", f, t), s("ex-structured-list-body", u, t), s("ex-structured-list-row", p, t), s("ex-structured-list-col", h, t), s("ex-structured-list-col-group", C, t), s("ex-structured-list-subheader", S, t);
}, A = c({ tagName: "ex-structured-list", elementClass: f, react: l, events: {}, displayName: "ExStructuredList", registerWebComponent: n }), W = c({ tagName: "ex-structured-list-body", elementClass: u, react: l, events: {}, displayName: "ExStructuredListBody", registerWebComponent: n }), O = c({ tagName: "ex-structured-list-row", elementClass: p, react: l, events: {}, displayName: "ExStructuredListRow", registerWebComponent: n }), _ = c({ tagName: "ex-structured-list-col", elementClass: h, react: l, events: {}, displayName: "ExStructuredListCol", registerWebComponent: n }), z = c({ tagName: "ex-structured-list-col-group", elementClass: C, react: l, events: {}, displayName: "ExStructuredListColGroup", registerWebComponent: n }), B = c({ tagName: "ex-structured-list-subheader", elementClass: S, react: l, events: {}, displayName: "ExStructuredListSubheader", registerWebComponent: n });
export {
  A as ExStructuredList,
  W as ExStructuredListBody,
  _ as ExStructuredListCol,
  z as ExStructuredListColGroup,
  O as ExStructuredListRow,
  B as ExStructuredListSubheader,
  u as SLBody,
  h as SLCol,
  C as SLColGroup,
  p as SLRow,
  S as SLSubheader,
  f as SList,
  E as StructuredListCellType,
  n as register
};
